import * as types from './constants'

const initialState = {
    waiting: false,
    accessToken: null,
    refreshToken: '',
    userId: null,
    isUserValidated: false,
    isForgotPasswordTokenSent: false,
    token: null,
    error: null,
}

const reducer = (state = initialState, actions) => {
    switch (actions.type) {
        case types.AUTH_START:
            return {
                ...state,
                error: null,
                waiting: true,
            }
        case types.AUTH_SUCCESS:
            return {
                ...state,
                isUserValidated: actions.isUserValidated,
                token: actions.token,
                error: null,
                waiting: false,
            }
        case types.AUTH_REFRESHED:
            return {
                ...state,
                accessToken: actions.accessToken,
                refreshToken: actions.refreshToken,
                waiting: false,
            }
        case types.AUTH_FAIL:
            return {
                ...state,
                error: actions.error,
                waiting: false,
            }
        case types.LOG_OUT:
            return {
                ...state,
                accessToken: null,
                refreshToken: '',
                userId: null,
                error: null,
                waiting: false,
            }
        case types.VALIDATION_START:
            return {
                ...state,
                waiting: true,
            }
        case types.VALIDATION_SUCCESS:
            return {
                ...state,
                token: actions.payload,
                waiting: false,
            }
        case types.VALIDATION_FAIL:
            return {
                ...state,
                error: actions.error,
                waiting: false,
            }
        case types.FORGOT_PASSWORD_STEP_ONE_START:
            return {
                ...state,
                waiting: true,
            }
        case types.FORGOT_PASSWORD_STEP_ONE_SUCCESS:
            return {
                ...state,
                waiting: false,
                isForgotPasswordTokenSent: true,
            }
        case types.FORGOT_PASSWORD_STEP_ONE_FAIL:
            return {
                ...state,
                error: actions.error,
                waiting: false,
            }
        case types.FORGOT_PASSWORD_STEP_TWO_START:
            return {
                ...state,
                waiting: true,
            }
        case types.FORGOT_PASSWORD_STEP_TWO_SUCCESS:
            return {
                ...state,
                token: actions.payload,
                waiting: false,
            }
        case types.FORGOT_PASSWORD_STEP_TWO_FAIL:
            return {
                ...state,
                error: actions.error,
                waiting: false,
            }
        case types.SET_ERROR:
            return {
                ...state,
                error: actions.error,
            }
        default:
            return state
    }
}

export default reducer
